import { css } from 'lit';

export default css`
  :host {
    display: grid;
    grid-template-columns: 35rem 1fr;
    --header-height: var(--maxH, 100%);
  }
  
  :host(.new-landing-page) {
    display: block;
    overflow-y: auto;
  }
  
  :host(.layout-content) {
    grid-template-columns: min(15vw,35rem) 1fr min(15vw,35rem);
  }

  lh-header {
    width: 400px;
  }

  ::slotted(:not(lh-questionnaire):not(lh-header)) {
    grid-column: span 2;
  }

  :host([data-device='desktop'][current-section='S_Summary_Details']) {
    grid-template-columns: 1fr;
  }
  :host([data-device='desktop'][current-section='S_Summary_Details'])
    ::slotted(lh-header) {
    display: none;
  }

  ::slotted(lh-questionnaire[current-section="S_Summary_Details"]) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }  


  :host([data-device='desktop'][current-section='S_MTA_Coverages']) {
    grid-template-columns: 1fr;
  }
  :host([data-device='desktop'][current-section='S_MTA_Coverages'])
    ::slotted(lh-header) {
    display: none;
  }

  ::slotted(lh-questionnaire[current-section="S_MTA_Coverages"]) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
`;
